/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteClientSecret$Params {
  organizationId: string;
  clientSecretName: string;
}

export function deleteClientSecret(http: HttpClient, rootUrl: string, params: DeleteClientSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteClientSecret.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('clientSecretName', params.clientSecretName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteClientSecret.PATH = '/v1/organizations/{organizationId}/clientsecret/{clientSecretName}';
